import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=e1b78caa&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b78caa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1b78caa')) {
      api.createRecord('e1b78caa', component.options)
    } else {
      api.reload('e1b78caa', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=e1b78caa&scoped=true&", function () {
      api.rerender('e1b78caa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2pffHNKBFfOvZ/JS/comp/Accordion.vue"
export default component.exports